var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CURRENT-Heal-Pass-41519",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heal-Pass-Purchase-3",
    transform: "translate(-543.000000, -648.000000)",
    fill: "#37600B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(528.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.000000, 387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9062887,7.66748662 L9.29734667,0.513311055 C9.72575661,-0.0552081296 10.5339273,-0.168789119 11.1024465,0.259620815 C11.6709657,0.68803075 11.7845467,1.49620148 11.3561368,2.06472066 L5.06026838,10.4196202 C4.93335265,10.5880431 4.77310795,10.7165391 4.59563879,10.8028451 C4.0832914,11.0831591 3.42759536,11.0063973 2.99375777,10.5725597 L0.609401005,8.18820296 C0.0822998813,7.66110184 0.0822998813,6.80650206 0.609401005,6.27940094 C1.13650213,5.75229982 1.9911019,5.75229982 2.51820303,6.27940094 L3.9062887,7.66748662 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check_green.2d83f1b00bd92d54940f93f88561dae4.svg";
export { ForwardRef as ReactComponent };